import {
  ACADEMIC_TITLE,
  CACH_TINH,
  COACH_STATUS,
  COMMENT_TYPE,
  CULTURAL_ROLL_CALL,
  EVALUATION_TYPE,
  LOAI_CHI_SO,
  EXAMINATION_STATUS,
  EXAMINATION_TYPE,
  INJURY_STATUS,
  PLAYER_ACQUISITION_STATUS,
  QUATIFICATION_TEST,
  QUATIFICATION_TEST_TYPE,
  ROUTINE_MEDICAL_CHECKUP_STATUS,
  SCOREING_METHOD,
  SEMESTER,
  LOAI_TIEU_CHI,
  COT_CAN_THIET_LAP_CONG_THUC,
  PROFESSIONAL_CLASS_STATUS,
  CATEGORY_WEEKLY_PLAN,
  LESSON_TYPE,
  FOOTBALL_MATCH_STATUS,
  PLAYER_ACTION_STATUS,
  QUATIFICATION_TEST_NUMBER
} from "./common.enum"

export enum EnumSelectOptionType {
  user = 'user',
  userId = 'userId',
  position = 'position',
  workingPosition = 'workingPosition',
  stores = 'stores',
  statusWork = 'statusWork',
  status = 'status',
  globalStatus = 'globalStatus',
  contractType = 'contractType',
  staffObject = 'staffObject',
  organization = 'organization',
  gender = 'gender',
  staffRole = 'staffRole',
  staffLevel = 'staffLevel',
  organizationType = 'organizationType',
  positionGroup = 'positionGroup',
  biddingConditions = 'biddingConditionsDto',
  isManager = 'isManager',
  isKey = 'isKey',
  isKeyMember = 'isKeyMember',
  statusDelete = 'statusDelete',
  statusActive = 'statusActive'
}

export enum AddressSelectorTypes {
  country = 'country',
  province = 'province',
  district = 'district',
  commune = 'commune',
  areaStore = 'areaStore',
  provinceStore = 'provinceStore',
  districtStore = 'districtStore',
  communeStore = 'communeStore',
}
export enum CSSelectOptionType {
  user = 'user',
  department = 'department',
  position = 'position',
  workingPosition = 'workingPosition',
  area = 'area',
  errorsGroup = 'errorsGrp',
  errors = 'errors',
  violations = 'violations',
  stores = 'stores',
  segment = 'segment',
  segmentType = 'segmentType',
  questionGroup = 'questionGrp',
  deliveryTypeName = 'deliveryTypeName',
  question = 'question',
  campaign = 'campaign',
  customerFiles = 'customerFiles',
  advertisingChannel = 'advertisingChannel',
  allAdvertisingChannel = 'allAdvertisingChannel',
  gender = 'gender',
  commodityGroup = 'commodityGroup',
  objective = 'objective',
  brand = 'brand',
  mktProduct = 'mktProduct',
  mktCampaignProduct = 'mktCampaignProduct',
  source_complaint = 'source_complaint',
  option_complaint = 'option_complaint',
  is_complete_profile = 'is_complete_profile',
  is_vip = 'is_vip',
  mainGroup = 'mainGroup', // danh sách ngành hàng
  is_verified = 'is_verified',
  list_update_source = 'list_update_source',
  is_online_order = 'is_online_order',
  is_active = 'is_active',
  status_release_customer = 'status_release_customer',
  status_call_out = 'status_call_out',
  bool_options = 'bool_options',
  customer_type = 'customer_type',
  switchboard_number = 'switchboard_number',
  cusTypeDefine = 'cusTypeDefine',
  channel_marketing = 'channel_marketing',
  is_success_online_order = 'is_success_online_order',
  sale_order_type = 'sale_order_type',
  call_center_agent_id = 'call_center_agent_id',
  angentHoaSao = 'angentHoaSao',
  listAgentGroupHoaSao = 'listAgentGroupHoaSao',
  listCustomer = 'listCustomer'
}

export const PERMISSION_STATUS_LIST = [
  { value: true, label: 'BASE.STATUS_LIST.ACTIVE2' },
  { value: false, label: 'BASE.STATUS_LIST.INACTIVE2' },
]

// export const STATUS_LIST = [
//   { value: true, label: 'Hoạt động' },
//   { value: false, label: 'Không hoạt động' },
// ]

export const STATUS_LIST = [
  { value: true, label: 'BASE.STATUS_LIST.ACTIVE' },
  { value: false, label: 'BASE.STATUS_LIST.INACTIVE' },
]

export const STATUS_MAIN_LIST = [
  { value: 1, label: 'BASE.STATUS_LIST.ACTIVE' },
  { value: 0, label: 'BASE.STATUS_LIST.INACTIVE' },
]

export const PATH = '/api'
export const PATH2 = ''

export const STATUS_COLOR: any = {
  green: { backgroundColor: '#dcf6e8', textColor: '#28C76F' },
  red: { backgroundColor: '#fbe3e4', textColor: '#ea5455' },
  blue: { backgroundColor: '#d6f7fb', textColor: '#00CFE8' },
  purple: { backgroundColor: '#e8e6fc', textColor: '#7367f0' },
  gray: { backgroundColor: '#a5a3ae', textColor: 'white' },
  purple2: { backgroundColor: '#e8e6fc', textColor: '#564db4' },
  orange: { backgroundColor: '#ffefe1', textColor: '#ff9f43' },
}

export const SCOREING_METHOD_DROPDOWN = [
  { value: SCOREING_METHOD.GRADING_SCALE, label: 'SCOREING_METHOD.GRADING_SCALE' },
  { value: SCOREING_METHOD.COMMENT, label: 'SCOREING_METHOD.COMMENT' },
  { value: SCOREING_METHOD.EVALUATION, label: 'SCOREING_METHOD.EVALUATION' },
]

// warning - màn sử dụng json data toàn tiếng việt từ api, không translate
export const SEMESTER_DROPDOWN = [
  { value: SEMESTER.SEMESTER1, label: 'Học kỳ I' },
  { value: SEMESTER.SEMESTER2, label: 'Học kỳ II' },
  { value: SEMESTER.FINAL, label: 'CN' },
]

export const COMMENT_TYPE_LIST = [
  { value: COMMENT_TYPE.d, label: 'COMMENT_TYPE.PASS' },
  { value: COMMENT_TYPE.kd, label: 'COMMENT_TYPE.FAIL' },
  { value: COMMENT_TYPE.g, label: 'COMMENT_TYPE.EXCELLENT' },
  { value: COMMENT_TYPE.k, label: 'COMMENT_TYPE.GOOD' },
  { value: COMMENT_TYPE.tb, label: 'COMMENT_TYPE.AVERAGE' }
]

export const EVALUATION_TYPE_LIST = [
  { value: EVALUATION_TYPE.d, label: 'COMMENT_TYPE.PASS' },
  { value: EVALUATION_TYPE.kd, label: 'COMMENT_TYPE.FAIL' }
]

export const ACADEMIC_TITLE_LIST = [
  { value: ACADEMIC_TITLE.EXCELLENT, label: 'CATEGORY_MANAGEMENT.ACADEMIC_TITLE.EXCELLENT' },
  { value: ACADEMIC_TITLE.GOOD, label: 'CATEGORY_MANAGEMENT.ACADEMIC_TITLE.GOOD' }
]

export const PROMOTION_FLAG: any = {
  UP: true, // Lên lớp
  DOWN: false // Lưu ban
}

export const PROMOTION_FLAG_LIST = [
  { value: PROMOTION_FLAG.UP, label: 'CATEGORY_MANAGEMENT.PROMOTION_FLAG.UP' },
  { value: PROMOTION_FLAG.DOWN, label: 'CATEGORY_MANAGEMENT.PROMOTION_FLAG.DOWN' }
]

export const PLAYER_ACQUISITION_STATUS_LIST = [
  { value: PLAYER_ACQUISITION_STATUS.REGISTERED, label: 'PLAYER_ACQUISITION_STATUS.REGISTERED' },
  { value: PLAYER_ACQUISITION_STATUS.IN_TRAINING, label: 'PLAYER_ACQUISITION_STATUS.IN_TRAINING' },
  { value: PLAYER_ACQUISITION_STATUS.INJURED, label: 'PLAYER_ACQUISITION_STATUS.INJURED' },
  { value: PLAYER_ACQUISITION_STATUS.ON_LOAN, label: 'PLAYER_ACQUISITION_STATUS.ON_LOAN' },
  { value: PLAYER_ACQUISITION_STATUS.RELEASED, label: 'PLAYER_ACQUISITION_STATUS.RELEASED' },
  { value: PLAYER_ACQUISITION_STATUS.TRANSFERRED, label: 'PLAYER_ACQUISITION_STATUS.TRANSFERRED' },
  { value: PLAYER_ACQUISITION_STATUS.CURRENTLY_PLAYING, label: 'PLAYER_ACQUISITION_STATUS.CURRENTLY_PLAYING' }
]

// dành riêng cho cầu thủ đào tạo
export const PLAYER_TRAINED_STATUS_LIST = [
  { value: PLAYER_ACQUISITION_STATUS.IN_TRAINING, label: 'PLAYER_ACQUISITION_STATUS.IN_TRAINING' },
  { value: PLAYER_ACQUISITION_STATUS.INJURED, label: 'PLAYER_ACQUISITION_STATUS.INJURED' },
  { value: PLAYER_ACQUISITION_STATUS.ON_LOAN, label: 'PLAYER_ACQUISITION_STATUS.ON_LOAN' },
  { value: PLAYER_ACQUISITION_STATUS.RELEASED, label: 'PLAYER_ACQUISITION_STATUS.RELEASED' },
  { value: PLAYER_ACQUISITION_STATUS.TRANSFERRED, label: 'PLAYER_ACQUISITION_STATUS.TRANSFERRED' },
  { value: PLAYER_ACQUISITION_STATUS.CURRENTLY_PLAYING, label: 'PLAYER_ACQUISITION_STATUS.CURRENTLY_PLAYING' }
]


export const GENDER_LIST = [
  { value: 'Nam', label: 'USER.GENDER_MALE' },
  { value: 'Nữ', label: 'USER.GENDER_FEMALE' },
]

export const DOMINANT_FOOT = [
  { value: '0', label: 'PLAYER_MANAGE.DOMINANT_FOOT.RIGHT' },
  { value: '1', label: 'PLAYER_MANAGE.DOMINANT_FOOT.LEFT' },
  { value: '2', label: 'PLAYER_MANAGE.DOMINANT_FOOT.BOTH' },
]

export const COACH_STATUS_LIST = [
  { value: COACH_STATUS.ACTIVE_COACH, label: 'BASE.STATUS_LIST.ACTIVE_COACH' },
  { value: COACH_STATUS.INACTIVE_COACH, label: 'BASE.STATUS_LIST.INACTIVE_COACH' },
]

export const COACH_STATUS_NAME: { [key: string]: string } = {
  [COACH_STATUS.ACTIVE_COACH]: 'BASE.STATUS_LIST.ACTIVE_COACH',
  [COACH_STATUS.INACTIVE_COACH]: 'BASE.STATUS_LIST.INACTIVE_COACH'
}

export const ROUTINE_MEDICAL_CHECKUP_STATUS_LIST = [
  { value: ROUTINE_MEDICAL_CHECKUP_STATUS.NOT_YET_STARTED, label: 'BASE.STATUS_LIST.NOT_YET_STARTED' },
  { value: ROUTINE_MEDICAL_CHECKUP_STATUS.IN_PROGRESS, label: 'BASE.STATUS_LIST.IN_PROGRESS' },
  { value: ROUTINE_MEDICAL_CHECKUP_STATUS.FINISHED, label: 'BASE.STATUS_LIST.FINISHED' }
]

export const ROUTINE_MEDICAL_CHECKUP_STATUS_NAME: { [key: string]: string } = {
  [ROUTINE_MEDICAL_CHECKUP_STATUS.NOT_YET_STARTED]: 'BASE.STATUS_LIST.NOT_YET_STARTED',
  [ROUTINE_MEDICAL_CHECKUP_STATUS.IN_PROGRESS]: 'BASE.STATUS_LIST.ON_GOING',
  [ROUTINE_MEDICAL_CHECKUP_STATUS.FINISHED]: 'BASE.STATUS_LIST.FINISHED'
}

export const EXAMINATION_TYPE_LIST = [
  { value: EXAMINATION_TYPE.KHAM_SUC_KHOE_DINH_KY, label: 'ROUTINE_MEDICAL_CHECK_UP.KHAM_SUC_KHOE_DINH_KY' },
  { value: EXAMINATION_TYPE.KHAM_Y_TE_TUYEN_DAU_VAO, label: 'ROUTINE_MEDICAL_CHECK_UP.KHAM_Y_TE_TUYEN_DAU_VAO' },
  { value: EXAMINATION_TYPE.KHAM_SUC_KHOE_TRUOC_NGHI_HE, label: 'ROUTINE_MEDICAL_CHECK_UP.KHAM_SUC_KHOE_TRUOC_NGHI_HE' },
  { value: EXAMINATION_TYPE.KHAM_SUC_KHOE_SAU_NGHI_HE, label: 'ROUTINE_MEDICAL_CHECK_UP.KHAM_SUC_KHOE_SAU_NGHI_HE' },
  { value: EXAMINATION_TYPE.KHAM_SUC_KHOE_TRUOC_NGHI_TET, label: 'ROUTINE_MEDICAL_CHECK_UP.KHAM_SUC_KHOE_TRUOC_NGHI_TET' },
  { value: EXAMINATION_TYPE.KHAM_SUC_KHOE_SAU_NGHI_TET, label: 'ROUTINE_MEDICAL_CHECK_UP.KHAM_SUC_KHOE_SAU_NGHI_TET' },
  { value: EXAMINATION_TYPE.KHAM_SUC_KHOE_TRUOC_THI_DAU, label: 'ROUTINE_MEDICAL_CHECK_UP.KHAM_SUC_KHOE_TRUOC_THI_DAU' },
  { value: EXAMINATION_TYPE.KHAM_Y_HOC_TDTT_DAU_VAO, label: 'ROUTINE_MEDICAL_CHECK_UP.KHAM_Y_HOC_TDTT_DAU_VAO' },
]

export const EXAMINATION_STATUS_LIST = [
  { value: EXAMINATION_STATUS.CHUA_CO_KET_QUA, label: 'INJURY.NO_RESULT_YET' },
  { value: EXAMINATION_STATUS.DA_CO_KET_QUA, label: 'INJURY.RESULT_AVAILABLE' }
]

export const EXAMINATION_STATUS_NAME: { [key: number]: string } = {
  [EXAMINATION_STATUS.CHUA_CO_KET_QUA]: 'INJURY.NO_RESULT_YET',
  [EXAMINATION_STATUS.DA_CO_KET_QUA]: 'INJURY.RESULT_AVAILABLE'
}

export const INJURY_STATUS_LIST = [
  { value: INJURY_STATUS.DA_KHOI, label: 'INJURY.RECOVERED2' },
  { value: INJURY_STATUS.CHAN_THUONG, label: 'INJURY.INJURED' }
]

export const INJURY_STATUS_NAME: { [key: string]: string } = {
  [INJURY_STATUS.DA_KHOI]: 'INJURY.RECOVERED2',
  [INJURY_STATUS.CHAN_THUONG]: 'INJURY.INJURED'
}
export const USER_STATUS = [
  { value: true, label: 'BASE.STATUS_LIST.ACTIVE2' },
  { value: false, label: 'BASE.STATUS_LIST.INACTIVE' },
]

export const QUATIFICATION_TEST_LIST = [
  { value: QUATIFICATION_TEST.NOT_STARTED, label: 'BASE.STATUS_LIST.NOT_YET_STARTED2' },
  { value: QUATIFICATION_TEST.IN_PROGRESS, label: 'BASE.STATUS_LIST.IN_PROGRESS' },
  // { value: QUATIFICATION_TEST.RESULT_AVAILABLE, label: 'INJURY.RESULT_AVAILABLE' },
  { value: QUATIFICATION_TEST.COMPLETED, label: 'BASE.STATUS_LIST.COMPLETED' },
  { value: QUATIFICATION_TEST.NOT_FORWARDED_TO_TECHNICAL_REVIEW, label: 'BASE.STATUS_LIST.NOT_FORWARDED_TO_TECHNICAL_REVIEW' },
  { value: QUATIFICATION_TEST.FORWARDED_TO_TECHNICAL_REVIEW, label: 'BASE.STATUS_LIST.FORWARDED_TO_TECHNICAL_REVIEW' },
]

export const QUATIFICATION_TEST_LIST_NUMBER = [
  { value: QUATIFICATION_TEST_NUMBER.NOT_STARTED, label: 'BASE.STATUS_LIST.NOT_YET_STARTED' },
  { value: QUATIFICATION_TEST_NUMBER.IN_PROGRESS, label: 'Trong tiến trình' },
  // { value: QUATIFICATION_TEST.RESULT_AVAILABLE, label: 'INJURY.RESULT_AVAILABLE' },
  { value: QUATIFICATION_TEST_NUMBER.COMPLETED, label: 'BASE.STATUS_LIST.COMPLETED' },
  { value: QUATIFICATION_TEST_NUMBER.NOT_FORWARDED_TO_TECHNICAL_REVIEW, label: 'BASE.STATUS_LIST.NOT_FORWARDED_TO_TECHNICAL_REVIEW' },
  { value: QUATIFICATION_TEST_NUMBER.FORWARDED_TO_TECHNICAL_REVIEW, label: 'BASE.STATUS_LIST.FORWARDED_TO_TECHNICAL_REVIEW' },
]


export const LOAI_CHI_SO_LIST = [
  { value: LOAI_CHI_SO.COUNT, label: 'METRIC.COUNT' },
  { value: LOAI_CHI_SO.DIRECTIONAL, label: 'METRIC.DIRECTIONAL' },
  { value: LOAI_CHI_SO.TARGET_TIME, label: 'METRIC.TARGET_TIME' },
]

export const CACH_TINH_LIST = [
  { value: CACH_TINH.INPUT_RESULT, label: 'CALCULATION_METHOD.INPUT_RESULT' },
  { value: CACH_TINH.FORMULA, label: 'CALCULATION_METHOD.FORMULA' },
]

export const QUATIFICATION_TEST_NAME: { [key: string]: string } = {
  [QUATIFICATION_TEST.NOT_STARTED]: 'BASE.STATUS_LIST.NOT_YET_STARTED',
  [QUATIFICATION_TEST.IN_PROGRESS]: 'BASE.STATUS_LIST.IN_PROGRESS2',
  // [QUATIFICATION_TEST.RESULT_AVAILABLE]: 'INJURY.RESULT_AVAILABLE',
  [QUATIFICATION_TEST.COMPLETED]: 'BASE.STATUS_LIST.COMPLETED',
  [QUATIFICATION_TEST.NOT_FORWARDED_TO_TECHNICAL_REVIEW]: 'BASE.STATUS_LIST.NOT_FORWARDED_TO_TECHNICAL_REVIEW',
  [QUATIFICATION_TEST.FORWARDED_TO_TECHNICAL_REVIEW]: 'BASE.STATUS_LIST.FORWARDED_TO_TECHNICAL_REVIEW',

}

export const QUATIFICATION_TEST_COLOR: any = {
  [QUATIFICATION_TEST.NOT_STARTED]: STATUS_COLOR.orange,
  [QUATIFICATION_TEST.IN_PROGRESS]: STATUS_COLOR.blue,
  // [QUATIFICATION_TEST.RESULT_AVAILABLE]: STATUS_COLOR.gray,
  [QUATIFICATION_TEST.COMPLETED]: STATUS_COLOR.green,
  [QUATIFICATION_TEST.NOT_FORWARDED_TO_TECHNICAL_REVIEW]: STATUS_COLOR.purple,
  [QUATIFICATION_TEST.FORWARDED_TO_TECHNICAL_REVIEW]: STATUS_COLOR.purple2,


}

export const QUATIFICATION_TEST_TYPE_LIST = [
  { value: QUATIFICATION_TEST_TYPE.DINH_KY, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.PERIODIC_QUANLIFICATION_TEST' },
  { value: QUATIFICATION_TEST_TYPE.THI_TUYEN_DAU_VAO, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.EXTRANCE_EXAM' },
]

export const QUATIFICATION_TEST_TYPE_NAME: { [key: string]: string } = {
  [QUATIFICATION_TEST_TYPE.DINH_KY]: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.PERIODIC',
  [QUATIFICATION_TEST_TYPE.THI_TUYEN_DAU_VAO]: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.EXTRANCE_EXAM'
}


export const CULTURAL_ROLL_CALL_LIST = [
  { value: CULTURAL_ROLL_CALL.PRESENT, label: 'ATTENDANCE_SUMMARY.PRESENT' },
  { value: CULTURAL_ROLL_CALL.ABSENT_UNEXECUSED, label: 'ATTENDANCE_SUMMARY.ABSENT_UNEXECUSED' },
  { value: CULTURAL_ROLL_CALL.ABSENT_EXCUSED, label: 'ATTENDANCE_SUMMARY.ABSENT_EXCUSED' }
]

export const PLAYER_ACQUISITION_STATUS_NAME: { [key: string]: string } = {
  [PLAYER_ACQUISITION_STATUS.REGISTERED]: 'PLAYER_ACQUISITION_STATUS.REGISTERED',
  [PLAYER_ACQUISITION_STATUS.IN_TRAINING]: 'PLAYER_ACQUISITION_STATUS.IN_TRAINING',
  [PLAYER_ACQUISITION_STATUS.INJURED]: 'PLAYER_ACQUISITION_STATUS.INJURED',
  [PLAYER_ACQUISITION_STATUS.ON_LOAN]: 'PLAYER_ACQUISITION_STATUS.ON_LOAN',
  [PLAYER_ACQUISITION_STATUS.RELEASED]: 'PLAYER_ACQUISITION_STATUS.RELEASED',
  [PLAYER_ACQUISITION_STATUS.TRANSFERRED]: 'PLAYER_ACQUISITION_STATUS.TRANSFERRED',
  [PLAYER_ACQUISITION_STATUS.CURRENTLY_PLAYING]: 'PLAYER_ACQUISITION_STATUS.CURRENTLY_PLAYING',
}

export const PLAYER_ACQUISITION_STATUS_COLOR: any = {
  [PLAYER_ACQUISITION_STATUS.REGISTERED]: STATUS_COLOR.gray,
  [PLAYER_ACQUISITION_STATUS.IN_TRAINING]: STATUS_COLOR.green,
  [PLAYER_ACQUISITION_STATUS.INJURED]: STATUS_COLOR.orange,
  [PLAYER_ACQUISITION_STATUS.ON_LOAN]: STATUS_COLOR.blue,
  [PLAYER_ACQUISITION_STATUS.RELEASED]: STATUS_COLOR.red,
  [PLAYER_ACQUISITION_STATUS.TRANSFERRED]: STATUS_COLOR.purple2,
  [PLAYER_ACQUISITION_STATUS.CURRENTLY_PLAYING]: STATUS_COLOR.green,
}

export const LOAI_TIEU_CHI_LIST = [
  { value: LOAI_TIEU_CHI.TIEU_CHI_THE_LUC, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.PHYSICAL' },
  { value: LOAI_TIEU_CHI.TIEU_CHI_KY_NANG, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.SKILL' },
  { value: LOAI_TIEU_CHI.TIEU_CHI_KY_THUAT, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.TECHNICAL' },
  { value: LOAI_TIEU_CHI.TIEU_CHI_KY_THUAT_THU_MON, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.GOALKEEPER_TECHNICAL' },
  { value: LOAI_TIEU_CHI.BA_TEST, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.3TEST' },
]

export const LOAI_TIEU_CHI_LIST_THI_TUYEN = [
  { value: LOAI_TIEU_CHI.TIEU_CHI_THE_LUC, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.PHYSICAL' },
  { value: LOAI_TIEU_CHI.TIEU_CHI_KY_NANG, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.SKILL' },
  { value: LOAI_TIEU_CHI.TIEU_CHI_KY_THUAT, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.TECHNICAL' },
  // { value: LOAI_TIEU_CHI.DANH_GIA_NANG_KHIEU, label: 'Đánh giá năng khiếu' },
  // { value: LOAI_TIEU_CHI.DANH_GIA_Y_TE, label: 'Đánh giá y tế' },
]

export const TUONG_DUONG = [
  { value: LOAI_TIEU_CHI.TIEU_CHI_THE_LUC, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.PHYSICAL' },
  { value: LOAI_TIEU_CHI.TIEU_CHI_KY_NANG, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.SKILL' },
  { value: LOAI_TIEU_CHI.TIEU_CHI_KY_THUAT, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.TECHNICAL' },
  { value: LOAI_TIEU_CHI.TIEU_CHI_KY_THUAT_THU_MON, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.GOALKEEPER_TECHNICAL' },
  { value: LOAI_TIEU_CHI.BA_TEST, label: 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.CRITERIA_STATUS.3TEST' },
]

export const STATISTICAL = [
  { value: true, label: 'BASE.YES' },
  { value: false, label: 'BASE.NO' },
]

// export const COT_CAN_THIET_LAP_CONG_THUC_LIST = [
//   { value: COT_CAN_THIET_LAP_CONG_THUC.TOTAL_SCORE, label: 'Tổng điểm' },
//   { value: COT_CAN_THIET_LAP_CONG_THUC.CONVERTED_SCORE, label: 'Điểm quy đổi' },
//   { value: COT_CAN_THIET_LAP_CONG_THUC.PHYSICAL, label: 'Thể lực' },
//   { value: COT_CAN_THIET_LAP_CONG_THUC.TECHNICAL, label: 'Kỹ thuật' },
//   { value: COT_CAN_THIET_LAP_CONG_THUC.THINKING, label: 'Tư duy' },
// ];

export const PROFESSIONAL_CLASS_STATUS_LIST = [
  { value: PROFESSIONAL_CLASS_STATUS.NOT_STARTED, label: 'BASE.STATUS_LIST.NOT_YET_STARTED' },
  { value: PROFESSIONAL_CLASS_STATUS.IN_PROGRESS, label: 'BASE.STATUS_LIST.ON_GOING' },
  { value: PROFESSIONAL_CLASS_STATUS.COMPLETED, label: 'BASE.STATUS_LIST.COMPLETED2' }
]

export const PROFESSIONAL_CLASS_STATUS_COLOR: any = {
  [PROFESSIONAL_CLASS_STATUS.NOT_STARTED]: STATUS_COLOR.blue,
  [PROFESSIONAL_CLASS_STATUS.IN_PROGRESS]: STATUS_COLOR.orange,
  [PROFESSIONAL_CLASS_STATUS.COMPLETED]: STATUS_COLOR.green,
}

export const CATEGORY_WEEKLY_PLAN_LIST = [
  { value: CATEGORY_WEEKLY_PLAN.WARM_UP, label: 'CATEGORY_MANAGEMENT.WEEKLY_PLAN.WARM_UP' },
  { value: CATEGORY_WEEKLY_PLAN.MAIN, label: 'CATEGORY_MANAGEMENT.WEEKLY_PLAN.MAIN' },
  { value: CATEGORY_WEEKLY_PLAN.COOL_DOWN, label: 'BASE.STATUS_LIST.FINISHED' },
]

export const LESSON_TYPE_LIST = [
  { value: LESSON_TYPE.PROFESSIONAL, label: 'CATEGORY_MANAGEMENT.LESSON_TYPE.PROFESSIONAL' },
  { value: LESSON_TYPE.CULTURE, label: 'CATEGORY_MANAGEMENT.LESSON_TYPE.CULTURE' },
  { value: LESSON_TYPE.OTHER, label: 'CATEGORY_MANAGEMENT.LESSON_TYPE.OTHER' },
]

export const FOOTBALL_MATCH_STATUS_NAME: { [key: string]: string } = {
  [FOOTBALL_MATCH_STATUS.PENDING]: 'BASE.STATUS_LIST.PENDING',
  [FOOTBALL_MATCH_STATUS.IN_PROGRESS]: 'BASE.STATUS_LIST.MATCH_IN_PROGRESS',
  [FOOTBALL_MATCH_STATUS.COMPLETED]: 'BASE.STATUS_LIST.FINISHED',
  [FOOTBALL_MATCH_STATUS.POSTPONED]: 'BASE.STATUS_LIST.POSTPONED',
}

export const FOOTBALL_MATCH_STATUS_COLOR: any = {
  [FOOTBALL_MATCH_STATUS.PENDING]: STATUS_COLOR.gray,
  [FOOTBALL_MATCH_STATUS.IN_PROGRESS]: STATUS_COLOR.orange,
  [FOOTBALL_MATCH_STATUS.COMPLETED]: STATUS_COLOR.green,
  [FOOTBALL_MATCH_STATUS.POSTPONED]: STATUS_COLOR.red,
}

export const FOOTBALL_MATCH_STATUS_LIST = [
  { value: FOOTBALL_MATCH_STATUS.PENDING, label: 'BASE.STATUS_LIST.PENDING' },
  { value: FOOTBALL_MATCH_STATUS.IN_PROGRESS, label: 'BASE.STATUS_LIST.MATCH_IN_PROGRESS' },
  { value: FOOTBALL_MATCH_STATUS.COMPLETED, label: 'BASE.STATUS_LIST.FINISHED' },
  { value: FOOTBALL_MATCH_STATUS.POSTPONED, label: 'BASE.STATUS_LIST.POSTPONED' },
]

export const PLAYER_ACTION_LIST = [
  { value: PLAYER_ACTION_STATUS.ACTIVE, label: 'BUTTON.ACTIVE' },
  { value: PLAYER_ACTION_STATUS.INJURY, label: 'BUTTON.INJURY' },
  { value: PLAYER_ACTION_STATUS.RELEASE, label: 'BUTTON.LIQUIDATION' },
  { value: PLAYER_ACTION_STATUS.TRANSFER, label: 'BUTTON.TRANSFER' },
  { value: PLAYER_ACTION_STATUS.ROTATE, label: 'BUTTON.ROTATE' },
  { value: PLAYER_ACTION_STATUS.ON_LOAN, label: 'BUTTON.LOAN' },
]

export const PLAYER_ACTION_COLOR: any = {
  [PLAYER_ACTION_STATUS.ACTIVE]: STATUS_COLOR.green,
  [PLAYER_ACTION_STATUS.INJURY]: STATUS_COLOR.orange,
  [PLAYER_ACTION_STATUS.RELEASE]: STATUS_COLOR.red,
  [PLAYER_ACTION_STATUS.TRANSFER]: STATUS_COLOR.purple,
  [PLAYER_ACTION_STATUS.ROTATE]: STATUS_COLOR.blue,
}

export const INJURY_DOC_TYPE = {
  MEDICAL: 'medical',
  "B1": "b1",
  "B2": "b2",
  "B3": "b3",
  "B4": "b4",
  "B5": "b5",
  "B6": "b6",
  "B7": "b7",
  "B8": "b8"
}
